import { forwardRef, type InputHTMLAttributes } from 'react'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  hint?: string
  error?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, error, id, className = '', ...rest },
  ref,
) {
  const inputId = id || rest.name || `in-${Math.random().toString(36).slice(2)}`
  return (
    <div className={`field ${error ? 'field-error' : ''}`}>
      {label ? <label htmlFor={inputId}>{label}</label> : null}
      <input id={inputId} ref={ref} className={`input ${className}`} {...rest} />
      {hint && !error ? <small className="hint">{hint}</small> : null}
      {error ? <small className="err">{error}</small> : null}
    </div>
  )
})
